var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scroller",class:['tva-scroller', _vm.orientation]},[_c('div',{ref:"foreground",staticClass:"foreground"},[_vm._t("foreground")],2),_c('div',{ref:"background",staticClass:"background"},[_vm._t("background")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }